import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import SectionHeading from "../../SectionHeading";
import { fadeUp, revealOnce, stagger } from "../../motion";
import web_dev from "../../../Assets/Images/coding.png";
import MAM from "../../../Assets/Images/device.png";
import launch from "../../../Assets/Images/security.png";
import IT_Support from "../../../Assets/Images/4230745.png";
import ram from "../../../Assets/Images/ram.png";
import research_analysis from "../../../Assets/Images/market-analysis.png";
import "../../css/ServicesSection.css";

const SERVICES = [
  {
    id: "01",
    title: "Information & Network Security",
    description:
      "Robust cybersecurity solutions that safeguard your data and systems from potential threats — and give you peace of mind.",
    image: launch,
  },
  {
    id: "02",
    title: "Information Technology Support",
    description:
      "Reliable IT support to troubleshoot issues, maintain smooth operations, and maximize your organization's productivity.",
    image: IT_Support,
  },
  {
    id: "03",
    title: "Mobile Device & Application Management",
    description:
      "MDM/MAM solutions to secure and streamline your organization's mobile environment across every device.",
    image: MAM,
  },
  {
    id: "04",
    title: "Software Development & Maintenance",
    description:
      "I transform ideas into dynamic, interactive software with a seamless user experience to help your business thrive online.",
    image: web_dev,
  },
  {
    id: "05",
    title: "Computer Hardware Solutions",
    description:
      "Hardware support for businesses and individuals — from diagnosis and repair to upgrades and installations.",
    image: ram,
  },
  {
    id: "06",
    title: "Research & Analysis",
    description:
      "Uncovering valuable insights through meticulous research and analysis to optimize strategies and enhance performance.",
    image: research_analysis,
  },
];

const ServicesSection = () => {
  return (
    <section className="section services">
      <div className="container">
        <SectionHeading
          eyebrow="Services"
          title="Turning concepts into tangible solutions"
        />

        <motion.div className="services__grid" variants={stagger} {...revealOnce}>
          {SERVICES.map((service) => (
            <motion.article
              key={service.id}
              className="service-card"
              variants={fadeUp}
            >
              <div className="service-card__top">
                <span className="service-card__icon">
                  <img src={service.image} alt="" aria-hidden="true" loading="lazy" />
                </span>
                <span className="service-card__id">{service.id}</span>
              </div>
              <h3 className="service-card__title">{service.title}</h3>
              <p className="service-card__text">{service.description}</p>
              <Link to="/Services" className="service-card__link">
                Read more
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M8 7a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V9.414l-8.293 8.293a1 1 0 0 1-1.414-1.414L14.586 8H9a1 1 0 0 1-1-1z"
                    fill="currentColor"
                  />
                </svg>
              </Link>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesSection;
